import { Components, Theme } from '@mui/material';

export const dividerOverrides: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      background: theme.palette.borders.main,
      flex: 1,
    }),
  },
};
